import React, { useContext, useEffect } from "react";
import EventHandler from "../../../event-handler";

enum Events {
    UPDATED = "UPDATED"
}
export class FilterListState<T = unknown> {
    private selectedItem?: T;

    private events = new EventHandler<Events>();

    constructor(
        public readonly onChangeSelected?: (item: T) => void,
    ) {
        //
    }

    public useSelected(item?: T) {
        this.events.useEvent(Events.UPDATED);

        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            this.selectedItem = item;
            this.events.emit(Events.UPDATED);
        }, [item]);
    }

    public useButton() {
        this.events.useEvent(Events.UPDATED);
        return [
            this.selectedItem,
            (item: T) => {
                if (this.selectedItem === item) {
                    return;
                }
                this.selectedItem = item;
                this.events.emit(Events.UPDATED);
                if (this.onChangeSelected) {
                    this.onChangeSelected(item);
                }
            },
        ] as const;
    }
}
export const FilterListContext = React.createContext<FilterListState>(new FilterListState());

export default function useFilterState<T>(): FilterListState<T> {
    return useContext(FilterListContext) as unknown as FilterListState<T>;
}
